import {
  Typography,
  Rating,
  TextField,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import * as Yup from "yup";
import { fetchProductById, setCurrentProduct } from "../../../State/customer/ProductSlice";
import { createReview } from "../../../State/customer/ReviewSlice";
import { ReviewReq } from "../../../types/reviewType";
import { AddPhotoAlternate, Close } from "@mui/icons-material";
import { uploadImageToCloudinary } from "../../../State/seller/sellerUploadToCloudinary";
export const ReviewForm = () => {
  const [value, setValue] = useState<number | null>(0);
  const validationSchema = Yup.object({
    reviewRating: Yup.number()
      .required("Rating is required")
      .min(1, "Please leave a rating at least 1 star"),
    reviewText: Yup.string().required("Review Comment is required"),
    productImages: Yup.array().min(1, "At least one image is required"),
  });
  const [uploadImage, setUploadImage] = useState(false);
  const navigate = useNavigate();
  const { product } = useAppSelector((store) => store);
  const dispatch = useAppDispatch();
  const { orderId, productId } = useParams();
  const formik = useFormik({
    initialValues: {
      reviewRating: 0,
      productImages: [],
      reviewText: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: ReviewReq) => {
      // Submit logic here
      //   await dispatch(
      //     editProduct({ req: values, productId: sellerProduct.product?.id })
      //   );

    try {
     
      setTimeout(async() => { 
        await dispatch(
          createReview({
            req: values,
            orderId: Number(orderId),
            productId: Number(productId),
          })
        );
        navigate(`/reviews/${productId}`)
       },800)
    } catch (error) {

    }
    },
  });

  const handleRemoveImage = (index: number) => {
    // Remove the image at the specified index
    const updatedImages = [...(formik.values.productImages || [])];
    // remove the image from the images array
    updatedImages.splice(index, 1);
    // Update the images field in Formik
    formik.setFieldValue("productImages", updatedImages);
  };

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
  
    try {
      setUploadImage(true);
      const url = await dispatch(uploadImageToCloudinary(file)).unwrap();
      formik.setFieldValue("images", [...formik.values.productImages, url]);
    } catch (err) {
      console.error(err);
    } finally {
      setUploadImage(false);
    }
  };
  
  useEffect(() => {
    if (productId) {
      dispatch(fetchProductById(Number(productId)))
    .unwrap()
    .then(() => dispatch(setCurrentProduct(Number(productId))));
    }
  }, [productId]);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault(); // Prevent default form submission
        formik.handleSubmit(e);
      }}
    >
      <div className="md:flex justify-center gap-5 pt-5 ">
        <section className="w-full md:w-1/2 lg:w-[30%] space-y-2 ">
          <div className="w-[80%] m-auto">
            <img src={product.product?.images[0]} alt="" />
            <div className="">
              <div className="">
                <p className="font-bold text-xl">
                  {product.product?.sellerName}
                </p>
                <p className="text-lg text-gray-600">
                  {product.product?.title}
                </p>
              </div>
              <div className="">
                <div className="price flex items-center gap-3 mt-5 text-2xl">
                  <span className="font-sans text-gray-800">
                    {product.product?.sellingPrice}€
                  </span>
                  <span className="line-through text-gray-400">
                    {product.product?.mrpPrice}€
                  </span>
                  <span className="text-primary font-semibold ">
                    {product.product?.discountPercentage}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className=" space-y-3 pl-5  min-w-[40%] ">
          <h1 className="text-2xl font-bold text-gray-600">Review Form</h1>
          <Typography component="legend">Please leave a rating</Typography>
          <Rating
            size="large"
            name="reviewRating"
            value={formik.values.reviewRating}
            onChange={(_, newValue) => {
              formik.setFieldValue("reviewRating", newValue); // Update Formik's reviewRating value
              formik.setFieldTouched("reviewRating", true);
            }}
            onBlur={() => formik.setFieldTouched("reviewRating", true)} // Mark as touched manually
          />
          {formik.touched.reviewRating && formik.errors.reviewRating && (
            <Typography sx={{marginTop:"0px !important"}}  color="error">{formik.errors.reviewRating}</Typography>
          )}
          <div className="flex">
            
          <input
            type="file"
            accept="image/*"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
         
          {/* Custom Button for File Input */}
          <label htmlFor="fileInput" className="relative">
            <span className="w-24 h-24 cursor-pointer flex items-center justify-center border rounded-md">
              <AddPhotoAlternate className="text-gray-700" />
            </span>
            {/* Show Circular Progress if Uploading */}
            {uploadImage && (
              <div className="absolute left-0 right-0 top-0 bottom-0 w-24 h-24 flex items-center justify-center">
                <CircularProgress />
              </div>
            )}
          </label>
         
          <div className="flex flex-wrap gap-2">
            {(formik.values.productImages || []).map(
              (image: string, index: number) => (
                <div className="relative" key={index}>
                  {/* Render the uploaded image */}
                  <img
                    className="w-24 h-24 object-cover"
                    key={index}
                    src={image}
                    alt={`ProductImage ${index + 1}`}
                  />

                  {/* Render the delete button */}
                  <IconButton
                    onClick={() => handleRemoveImage(index)}
                    className=""
                    size="small"
                    color="error"
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      outline: "none",
                    }}
                  >
                    <Close />
                  </IconButton>
                </div>
              )
            )}
          </div>
          </div>
          {formik.touched.productImages && formik.errors.productImages && (
            <Typography color="error">{formik.errors.productImages}</Typography>
          )}
          <div className="w-[90%] space-y-7">
            <TextField
              className="w-[90%]"
              fullWidth
              name="reviewText"
              label="Comment"
              multiline
              rows={10}
              value={formik.values.reviewText}
              onChange={formik.handleChange}
              error={
                formik.touched.reviewText && Boolean(formik.errors.reviewText)
              }
              helperText={
                formik.touched.reviewText && formik.errors.reviewText
              }
            />
            <Button
              sx={{ p: "14px" }}
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
            
              // disabled={sellerProduct.loading}
            >
              {false ? (
                <CircularProgress
                  size="small"
                  sx={{ width: "27px", height: "27px" }}
                />
              ) : (
                "Save Comment"
              )}
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};
